import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from '@store/types';
import type { OnUpdatedMachineStatusSignalRResponse } from '@interfaces/machines';
import { loadSingleBatch } from '@reducers/batch/index';

export const refreshBatchOnMachineUpdateHandler = createAsyncThunk<
  void,
  OnUpdatedMachineStatusSignalRResponse,
  { state: RootState; dispatch: AppDispatch }
>('batch/refreshBatchOnMachineUpdateHandler', async (e, { dispatch, getState }) => {
  if (!e.changes?.includes('BatchDetails') || !e.changes?.includes('All')) return;

  const storedBatchId = getState().batch.batch.data?.productionBatchId;
  if (storedBatchId == null || Number(storedBatchId) !== Number(e.machineStatus?.productionBatchId)) return;

  dispatch(loadSingleBatch(storedBatchId));
});
